const calculateEndHour = (startingHour, liveHours) => {
  if (!startingHour || !startingHour?.value) {
    return '';
  }

  const hourString = startingHour?.value;
  const liveHoursString = liveHours?.value;

  if (liveHoursString === '' || liveHoursString == null) {
    return hourString;
  }

  const startHour = parseInt(hourString?.split(':')[0], 10);
  const endHour = startHour + parseInt(liveHoursString);

  return `${endHour?.toString().padStart(2, '0')}:00`;
};

export default calculateEndHour;
